<template>
  <div class="element-input element-time-select" :class="{ empty: !value }">
    <div class="label">{{ label }}</div>
    <div class="body">
      {{ value ? timeLabel : placeholder }}
      <i class="material-icons">expand_more</i>
      <!--<select v-model="model" >
        <option v-for="opt in times" :value="opt.value" >{{ opt.label }}</option>
      </select>-->
      <element-combo-box v-model="model" :items="en_times" />
    </div>
    <div class="error" v-if="error">{{ error }}</div>
  </div>
</template>
<script>

import moment from 'moment'

export default {
  props: [ "value", "label", "error", "items", "disabled", "placeholder", "date", 'isException' ],
  data() {
    return {
      moment: moment,
      times: [
        { value: "09:00", label: "오전 9시" },
        { value: "09:20", label: "오전 9시 20분" },
        { value: "09:40", label: "오전 9시 40분" },
        { value: "10:00", label: "오전 10시" },
        { value: "10:20", label: "오전 10시 20분" },
        { value: "10:40", label: "오전 10시 40분" },
        { value: "11:00", label: "오전 11시" },
        { value: "11:20", label: "오전 11시 20분" },
        { value: "11:40", label: "오전 11시 40분" },
        { value: "12:00", label: "오전 12시" },
        { value: "12:20", label: "오전 12시 20분" },
        { value: "12:40", label: "오전 12시 40분" },
        { value: "13:00", label: "오후 1시" },
        { value: "13:20", label: "오후 1시 20분" },
        { value: "13:40", label: "오후 1시 40분" },
        { value: "14:00", label: "오후 2시" },
        { value: "14:20", label: "오후 2시 20분" },
        { value: "14:40", label: "오후 2시 40분" },
        { value: "15:00", label: "오후 3시" },
        { value: "15:20", label: "오후 3시 20분" },
        { value: "15:40", label: "오후 3시 40분" },
        { value: "16:00", label: "오후 4시" },
        { value: "16:20", label: "오후 4시 20분" },
        { value: "16:40", label: "오후 4시 40분" },
        { value: "17:00", label: "오후 5시" },
        { value: "17:20", label: "오후 5시 20분" },
        { value: "17:40", label: "오후 5시 40분" },
        { value: "18:00", label: "오후 6시" },
      ]
    }
  },
  computed: {
    model: {
      get(){
        return this.value;
      },
      set( value ){
        this.$emit( "input", value );
      }
    },
    en_times: function () {

      if(new Date(this.date).toDateString() == new Date().toDateString()){
        var tlist = this.times.filter(o => o.value >= new Date().toTimeString());
        if(tlist.length > 0) {
          return tlist;
        }else{
          return [{ value: null, label: "오늘 상담은 종료되었습니다."}]
        }
      }else{
        return this.times;
      }
      
      
    },
    timeLabel() {
      const item = this.times.find(time => time.value === this.value) || { label: '오전 9시' };
      return item.label;
    }
  },
  mounted() {
    if (this.isException) {
      this.times =  [
        { value: "10:00", label: "오전 10시" },
        { value: "10:20", label: "오전 10시 20분" },
        { value: "10:40", label: "오전 10시 40분" },
        { value: "11:00", label: "오전 11시" },
        { value: "11:20", label: "오전 11시 20분" },
        { value: "11:40", label: "오전 11시 40분" },
        { value: "12:00", label: "오전 12시" },
        { value: "12:20", label: "오전 12시 20분" },
        { value: "12:40", label: "오전 12시 40분" },
        { value: "13:00", label: "오후 1시" },
        { value: "13:20", label: "오후 1시 20분" },
        { value: "13:40", label: "오후 1시 40분" },
        { value: "14:00", label: "오후 2시" },
        { value: "14:20", label: "오후 2시 20분" },
        { value: "14:40", label: "오후 2시 40분" },
        { value: "15:00", label: "오후 3시" },
        { value: "15:20", label: "오후 3시 20분" },
        { value: "15:40", label: "오후 3시 40분" },
        { value: "16:00", label: "오후 4시" },
        { value: "16:20", label: "오후 4시 20분" },
        { value: "16:40", label: "오후 4시 40분" },
        { value: "17:00", label: "오후 5시" },
      ]
    }
  }
}
</script>
